import { defineStore } from 'pinia'

export const useElements = defineStore('elements', {
  state: () => ({
    elements: {} as {
      shape: {
        rectangle: HTMLInputElement | null
        circle: HTMLInputElement | null
      }
      thickness: NodeListOf<HTMLInputElement>
      buttonsCols: HTMLInputElement | null
      buttonsRows: HTMLInputElement | null
      buttonsDistanceToEdge: HTMLInputElement | null
      stitchesDistanceToEdge: HTMLInputElement | null
      stitchesCols: HTMLInputElement | null
      stitchesRows: HTMLInputElement | null
      width_a_rectangle: HTMLInputElement | null
      length_b_rectangle: HTMLInputElement | null
      diameter_a_circle: HTMLInputElement | null
    },
  }),
})
